import { godModeRouteHidden } from '../../godMode/hidden';

/**
 * Navigation latérale en God Mode : retire les entrées qui mènent à un écran
 * masqué (Résultats, Benchmark, Compte, Facturation, Utilisateurs). Une section
 * dont tous les enfants disparaissent disparaît aussi. Pur : la configuration
 * d'origine n'est jamais modifiée, et hors God Mode elle est rendue telle quelle.
 */
export function filterNavigation(config, godMode) {
  if (!godMode) return config;
  const out = [];
  config.forEach((item) => {
    if (item.children) {
      const children = item.children.filter((c) => !godModeRouteHidden(c.href));
      if (children.length) out.push({ ...item, children });
    } else if (!godModeRouteHidden(item.href)) {
      out.push(item);
    }
  });
  return out;
}
